module.exports = __webpack_public_path__ + "img/icon_receive.a6c46918.svg";